module.exports = __webpack_public_path__ + "static/media/live-map.4309394f.svg";